import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../components/Loader";
import { LOCALES } from "common/constants";
import { useTranslation } from "react-i18next";
const AuthorizedForReminder = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const language = localStorage.getItem("i18nextLng");
   const { t } = useTranslation();
  // Function to extract query params from URL
  const getQueryParams = (query) => {
    return new URLSearchParams(query);
  };

  useEffect(() => {
    const queryParams = getQueryParams(location.search);
    const invoiceNumber = queryParams.get("InvoiceNumber");
    const isAuthorizedForReminder = queryParams.get("isAuthorizedForReminder") === "true";
    const token = queryParams.get("token");

    if (!invoiceNumber || !token) {
      setError(t("Missing required parameters."));
      setLoading(false);
      return;
    }

    const updateAuthorization = async () => {
      try {
        const response = await axios.put("/update-authorization", {
          invoiceNumber,
          isAuthorizedForReminder,
          token,
        });

        if (response.status !== 200) {
          throw new Error(t("Failed to authorize reminder."));
        }

        setLoading(false);
      } catch (err) {
        setError(err?.response?.data?.message || "An error occurred while authorizing.");
        setLoading(false);
      }
    };

    updateAuthorization();
  }, [location.search]);

  const closeTab = () => {
    if (window.opener) {
      window.close();
    } else {
      navigate(
       language === LOCALES.EN_US ? `/dashboard/activities?lang=${LOCALES.EN_US}` : `/dashboard/activities?lang=${LOCALES.SV_SE}`);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-100">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: "#FFE5E5" }}>
        <div className="card shadow-lg text-center p-4 p-md-5" style={{ maxWidth: "400px", borderRadius: "20px" }}>
          <h2 className="text-danger mb-3">Authorization Failed</h2>
          <p className="text-muted">{error}</p>
          <hr />
          <button
            className="btn btn-danger"
            onClick={closeTab}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: "#EAE2F8" }}>
      <div className="card shadow-lg text-center p-4 p-md-5" style={{ maxWidth: "400px", borderRadius: "20px" }}>
        <h2 className="text-primary mb-3" style={{ color: "#7B5DCB" }}>
          Reminder Activated
        </h2>
        <p className="text-muted">Thank you for authorizing Invozio to handle the customer reminder notification. We'll take it from here.</p>
        <hr />
        <p className="text-muted">
          <button
            className="btn btn-link text-decoration-none ms-1"
            style={{ color: "#3A63F0", fontWeight: "bold" }}
            onClick={() => navigate(
               language === LOCALES.EN_US ? `/dashboard/activities?lang=${LOCALES.EN_US}`  : `/dashboard/activities?lang=${LOCALES.SV_SE}`)}
          >
            Home page
          </button>
        </p>
      </div>
    </div>
  );
};

export default AuthorizedForReminder;
